import * as yup from "yup";
import { validationSchemas } from "./data";
export const moneyInSchema = yup.object().shape({
  moneyIn: validationSchemas.name,
});
